import { defineComponent, ref, computed, createBlock, openBlock, mergeProps, withCtx, createElementBlock, Fragment, renderList, normalizeStyle, createCommentVNode, createElementVNode, createVNode, createTextVNode, normalizeClass, toDisplayString, defineAsyncComponent, onBeforeMount } from "vue";
import { registerEntityEndpoint, getI18n, ROUTES, quasarValidateRules } from "@editor/ui-utils";
import { useQuasar, QImg, QCarouselSlide, QCarousel, useFormChild, QIcon, QDialog, QCardSection, QCard, QBtn } from "quasar";
import { useI18n } from "vue-i18n";
import { getImageUrl } from "@modules/image-editor-ui";
import { StatusIcon } from "@editor/ui-layout";
import { stateChangeIn } from "@modules/image-editor-ui/src/utils/time";
const de = {
  gallery: {
    title: "Hauptzeile",
    kicker: "Vorzeile",
    seoTitle: "SEO Titel",
    relatedGalleries: "Verwandte Galerien",
    linkGallery: "Galerie verlinken",
    addSelected: "Ausgewählte Galerien hinzufügen",
    license: "Lizenz",
    publishedAt: "Veröffentlichen am",
    expiredAt: "Ablaufdatum",
    savePublish: "Veröffentlichen",
    saveScheduled: "Schedule publication",
    inlineRendered: "Als Inline-Galerie rendern",
    adsEnabled: "Werbung aktiv",
    adTags: "Werbetags",
    messageMandatoryInformation: "Du kannst das Galerie nicht speichern, da benötigte Informationen fehlen",
    saveDraft: "Als Entwurf speichern",
    saveOffline: "Galerie offline nehmen",
    modeUnpublished: "Offline genommen",
    modeScheduled: "Veröffentlichung geplant",
    modePublished: "Veröffentlicht",
    modeDraft: "Entwurf",
    errorFailedLoadedGalleryWithId: "Fehler beim Laden der Galerie, Galerie mit uuid={id} nicht gefunden.",
    messageSaved: "Galerie gespeichert",
    messageEdited: "Galerie bearbeitet",
    messageDeleted: "Galerie gelöscht",
    messageDeleteGallery: "Sind Sie sicher, dass Sie dieses Galerie löschen möchten?",
    messageDeleteGalleryTitle: "Galerie löschen",
    messageConfirmUnpublishGallery: "Sind Sie sicher, dass Sie das Galerie offline nehmen möchten?",
    messageUnpublishGalleryTitle: "Galerie offline nehmen",
    messageConfirmDraftGallery: "Sind Sie sicher, dass Sie das Galerie als Entwurf festlegen möchten?",
    messagePublishTitle: "Galerie veröffentlichen",
    messagePublish: "Bist du sicher, dass du den Galerie veröffentlichen möchtest?",
    messageRepublishInFutureTitle: "Veröffentlichung verschieben",
    messageRepublishInFuture: "Sind Sie sicher, dass Sie das Galerie offline nehmen und für die zukünftige Veröffentlichung planen möchten?",
    addImage: "Bild hinzufügen",
    errorOnDeleting: "Es gibt ein Fehler beim Löschen der Gallerie",
    noEditTooltip: "Diese Galerie stammt ursprünglich aus dem {source}-Editor",
    toGallery: "zur Galerie",
    pathAutogenerate: "Pfad automatisch generieren",
    invalidOrigin: 'Der Bildursprung darf nicht "xymatic" sein',
    handledInLegacySystem: "Diese Galerie wird in {source} bearbeitet, du kannst sie nicht auf Vibe bearbeiten",
    requiredFields: "Sie können die Galerie nicht speichern, da Pflichtangaben fehlen",
    contentBlockLabel: "Galerie",
    router: {
      createGallery: "Galerie erstellen",
      editGallery: "Galerie bearbeiten"
    }
  },
  galleryList: {
    gallerySearch: "Nach Hauptzeile oder Vorzeile suchen",
    state: "Status",
    galleryTitle: "Vorzeile, Hauptzeile",
    galleryOfDay: "Galerie des Tages",
    newGallery: "Neue Galerie",
    images: "Bilder",
    preview: "Vorschau",
    editGallery: "Bearbeiten",
    viewGallery: "Anzeigen",
    deleteGallery: "Löschen",
    useGalleryOfDay: "Als Galeries des Tages verwenden",
    removeGalleryOfDay: "Nicht mehr als Galerie des Tages verwenden",
    searchByBrand: "Nach Marke suchen",
    galleryLabel: "Galerie auswählen oder hochladen",
    remove: "Entfernen",
    edit: "Bearbeiten",
    brand: "Marke"
  },
  states: {
    galleryDraft: "Entwurf",
    galleryPublish: "Online in {n} Tagen",
    galleryExpiresIn: "Läuft in {n} Tagen ab",
    galleryExpired: "Abgelaufen"
  }
};
const en = {
  gallery: {
    title: "Gallery Title",
    kicker: "Gallery Kicker",
    seoTitle: "SEO Title",
    relatedGalleries: "Related Galleries",
    linkGallery: "Link Gallery",
    addSelected: "Add Selected Galleries",
    license: "License (brand)",
    publishedAt: "Publish date",
    expiredAt: "Expiration Date",
    savePublish: "Publish",
    saveScheduled: "Schedule publication",
    inlineRendered: "Render as inline gallery",
    adsEnabled: "Ads enabled",
    adTags: "Ad tags",
    messageMandatoryInformation: "You can't save this gallery because it is missing mandatory information",
    saveDraft: "Save as Draft",
    saveOffline: "Take offline",
    modeUnpublished: "Gallery offline",
    modeScheduled: "Publishing date scheduled",
    modePublished: "Published",
    modeDraft: "Draft",
    errorFailedLoadedGalleryWithId: "Failed loading gallery, gallery with uuid={id} not found.",
    messageSaved: "Gallery Saved",
    messageEdited: "Gallery Edited",
    messageDeleted: "Gallery Deleted",
    messageDeleteGallery: "Are you sure you want to delete this gallery?",
    messageDeleteGalleryTitle: "Delete gallery",
    messageConfirmUnpublishGallery: "Are you sure you want to take gallery offline?",
    messageUnpublishGalleryTitle: "Take gallery offline",
    messageConfirmDraftGallery: "Are you sure you want to set gallery as draft?",
    messagePublishTitle: "Publish gallery",
    messagePublish: "Are you sure you want to publish this gallery?",
    messageRepublishInFutureTitle: "Reschedule publishing",
    messageRepublishInFuture: "Are you sure you want to take gallery offline and schedule it to be published in the future?",
    addImage: "Add image",
    errorOnDeleting: "There was an error deleting the gallery",
    noEditTooltip: "This gallery is originally from the {source} editor",
    toGallery: "To gallery",
    pathAutogenerate: "Automatically generate path",
    invalidOrigin: "Image origin cannot be xymatic",
    handledInLegacySystem: "This gallery is being handled in {source}, you can't edit it on Vibe",
    requiredFields: "You can't save the gallery because mandatory information is missing",
    contentBlockLabel: "Gallery",
    router: {
      createGallery: "Create Gallery",
      editGallery: "Edit Gallery"
    }
  },
  galleryList: {
    gallerySearch: "Search by title or kicker",
    state: "State",
    galleryTitle: "Kicker, Title",
    galleryOfDay: "Gallery of the day",
    newGallery: "New Gallery",
    images: "Images",
    preview: "Preview",
    editGallery: "Edit",
    viewGallery: "View",
    deleteGallery: "Delete",
    useGalleryOfDay: "Use as Gallery of the day",
    removeGalleryOfDay: "Dont use as Gallery of the day",
    searchByBrand: "Search by brand",
    galleryLabel: "Select or Upload a Gallery",
    remove: "Remove",
    edit: "Edit",
    brand: "Brand"
  },
  states: {
    galleryDraft: "Draft",
    galleryPublish: "Online in {n} days",
    galleryExpiresIn: "Expires in {n} days",
    galleryExpired: "Expired"
  }
};
const messages = { en, de };
const GalleryModelName = "Galleries";
const GalleryService = registerEntityEndpoint(GalleryModelName);
const { getEntity, listEntities, putEntity, postEntity, deleteEntity } = GalleryService;
const getGalleries = async (search, params = {}) => {
  return listEntities({ params: { search, ...params } });
};
const getGallery = async (id) => {
  return getEntity(id);
};
const postGallery = async (gallery) => {
  var _a;
  return postEntity({
    ...gallery,
    references: (_a = gallery.references) == null ? void 0 : _a.filter((asset) => asset.uuid)
    // filter out blank assets
  });
};
const editGallery = async (gallery, id) => {
  var _a;
  return putEntity(id, {
    ...gallery,
    references: (_a = gallery.references) == null ? void 0 : _a.filter((asset) => asset.uuid)
    // filter out blank assets
  });
};
const deleteGallery = async (id) => {
  return deleteEntity(id);
};
const getDefaultGalleryBlock = () => ({
  type: "GALLERY",
  galleryUuid: ""
});
const routes = [
  {
    path: `/${ROUTES.galleries.path}`,
    meta: { i18RouteTitleKey: ROUTES.galleries.path },
    children: [
      {
        path: "",
        name: "gallery_list",
        component: () => import("./gallery-list-DaRhuT5V.js").then((n) => n.a),
        meta: { requiredRight: "navigate_list_galleries" }
      },
      {
        path: "new",
        name: "gallery_new",
        component: () => import("./gallery-edit-Cnd_CTc1.js"),
        props: () => ({ title: getI18n().t("gallery.router.createGallery"), backRoute: "/galleries" }),
        meta: { requiredRight: "navigate_gallery" }
      },
      {
        path: ":id",
        name: "gallery_detail",
        component: () => import("./gallery-edit-Cnd_CTc1.js"),
        props: (route) => ({ title: getI18n().t("gallery.router.editGallery"), id: route.params.id, backRoute: "/galleries" }),
        meta: { requiredRight: "navigate_gallery" }
      }
    ]
  }
];
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "gallery-preview-carousel",
  props: {
    references: { type: Array, required: true },
    previewCount: { type: Number, required: false, default: 4 },
    previewSize: { type: Object, required: true }
  },
  emits: ["update:previewCount"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const q = useQuasar();
    q.screen.setSizes({ sm: 320, md: 768, lg: 1024, xl: 1400 });
    const emit = __emit;
    const props = __props;
    const activeSlide = ref(0);
    const numberOfVisibleSlides = computed({
      get() {
        if (q.screen.sm || q.screen.md) {
          return 2;
        } else if (q.screen.lg) {
          return 3;
        }
        return props.previewCount;
      },
      set(value) {
        emit("update:previewCount", value);
      }
    });
    const getCarouselSlides = computed(
      () => props.references.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (rows, key, index) => (index % numberOfVisibleSlides.value == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows,
        []
      )
    );
    const __returned__ = { q, emit, props, activeSlide, numberOfVisibleSlides, getCarouselSlides, get getImageUrl() {
      return getImageUrl;
    }, get QCarousel() {
      return QCarousel;
    }, get QCarouselSlide() {
      return QCarouselSlide;
    }, get QImg() {
      return QImg;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QCarousel"], mergeProps($setup.props, {
    modelValue: $setup.activeSlide,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.activeSlide = $event),
    height: `${$setup.props.previewSize.height}px`,
    style: { width: "auto" },
    class: "gallery-carousel"
  }), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.getCarouselSlides, (slide, index) => {
          return openBlock(), createBlock($setup["QCarouselSlide"], {
            key: index,
            class: "q-pa-none gallery-carousel__slide",
            name: index
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList(slide, (preview) => {
                  return openBlock(), createBlock($setup["QImg"], {
                    key: preview.uuid,
                    src: $setup.getImageUrl(preview.uuid, $setup.props.previewSize.width, $setup.props.previewSize.height),
                    style: normalizeStyle({
                      width: $props.previewSize.width + "px",
                      height: $props.previewSize.height + "px"
                    })
                  }, null, 8, ["src", "style"]);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["name"]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    _: 1
    /* STABLE */
  }, 16, ["modelValue", "height"]);
}
const galleryPreviewCarousel = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-1a2589dd"], ["__file", "/builds/CT/content-technology-framework/modules/gallery/editor-ui/src/components/gallery-preview-carousel.vue"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "gallery-state-overlay",
  props: {
    gallery: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const props = __props;
    const onlineIn = computed(() => stateChangeIn(props.gallery.publishDate));
    const expireIn = computed(() => stateChangeIn(props.gallery.unpublishDate));
    const statusMap = {
      draft: { icon: "edit-3", text: "states.galleryDraft", color: "text-grey" },
      schedule: { icon: "clock", text: "states.galleryPublish", color: "text-light-blue" },
      unpublish: { icon: "alert-circle", text: "states.galleryExpired", color: "text-red" },
      publish: { icon: "clock", text: "states.galleryExpiresIn", color: "text-red" }
    };
    const getStateProperties = computed(() => statusMap[props.gallery.state]);
    const __returned__ = { t, props, onlineIn, expireIn, statusMap, getStateProperties, get StatusIcon() {
      return StatusIcon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = {
  key: 0,
  class: "gallery-overlay absolute-full flex flex-center"
};
const _hoisted_2$1 = { class: "relative-center text-subtitle2 gallery-overlay-label text-dark" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return $setup.props.gallery.state !== "publish" || $setup.props.gallery.state === "publish" && $setup.props.gallery.unpublishDate ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", _hoisted_2$1, [
      createVNode($setup["StatusIcon"], {
        value: (_a = $setup.getStateProperties) == null ? void 0 : _a.icon,
        class: normalizeClass(["gallery-overlay-icon", $setup.getStateProperties.color])
      }, null, 8, ["value", "class"]),
      createTextVNode(
        " " + toDisplayString($setup.t((_b = $setup.getStateProperties) == null ? void 0 : _b.text, { n: $setup.props.gallery.state === "publish" ? $setup.expireIn : $setup.onlineIn })),
        1
        /* TEXT */
      )
    ])
  ])) : createCommentVNode("v-if", true);
}
const GalleryStateOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-2771ada6"], ["__file", "/builds/CT/content-technology-framework/modules/gallery/editor-ui/src/components/gallery-state-overlay.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "gallery-list.selector",
  props: {
    modelValue: { type: String, required: false, default: void 0 },
    rules: { type: Array, required: false, default: void 0 },
    state: { type: String, required: false, default: void 0 },
    license: { type: String, required: false, default: void 0 },
    width: { type: String, required: false, default: "100" },
    height: { type: String, required: false, default: "100" },
    required: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue", "update:gallery"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const GalleryEdit = defineAsyncComponent(() => import("./gallery-edit-Cnd_CTc1.js"));
    const GalleryList = defineAsyncComponent(() => import("./gallery-list-DaRhuT5V.js").then((n) => n.a));
    const props = __props;
    const emit = __emit;
    const getEmptyGallery = () => ({
      _id: "",
      bfJobUuid: "",
      title: "",
      isDeleted: false,
      createDate: /* @__PURE__ */ new Date(),
      changeDate: /* @__PURE__ */ new Date(),
      state: "draft",
      adsEnabled: false,
      inlineRendered: false,
      references: [],
      type: "GALLERY",
      brand: void 0,
      legacy: {
        source: "vibe",
        isEditableInCTF: true,
        isRenderedByCTF: true,
        hasBeenModifiedInCTF: true
      },
      authorUuids: [],
      seoTitle: ""
    });
    const { t } = useI18n();
    const showGalleryDialog = ref(false);
    const showEditDialog = ref(false);
    const isValid = ref(true);
    const galleryData = ref(getEmptyGallery());
    const validationMsg = ref("");
    const wrapper = ref();
    const ImageWidth = parseInt(props == null ? void 0 : props.width, 10);
    const ImageHeight = parseInt(props == null ? void 0 : props.height, 10);
    const showDialog = computed(() => showEditDialog.value || showGalleryDialog.value);
    const validateRules = () => {
      const validationRulesResult = quasarValidateRules(galleryData.value, props.rules);
      isValid.value = !validationRulesResult;
      validationMsg.value = validationRulesResult;
    };
    useFormChild({
      validate() {
        var _a;
        validateRules();
        if (!isValid.value) {
          (_a = wrapper.value) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
        return isValid.value;
      },
      resetValidation() {
        isValid.value = true;
      }
    });
    const showSelectedGallery = (gallery) => {
      galleryData.value = gallery;
      showGalleryDialog.value = false;
      validateRules();
      emit("update:modelValue", galleryData.value._id);
      emit("update:gallery", gallery);
    };
    const clearGallery = () => {
      galleryData.value = getEmptyGallery();
      emit("update:modelValue");
    };
    const openNewGallery = () => {
      showEditDialog.value = true;
      showGalleryDialog.value = false;
    };
    const onSave = (gallery) => {
      if (!gallery)
        return;
      showEditDialog.value = false;
      galleryData.value = gallery;
      emit("update:modelValue", gallery._id);
      emit("update:gallery", gallery);
      validateRules();
    };
    onBeforeMount(async () => {
      if (props.modelValue) {
        galleryData.value = await getGallery(props.modelValue);
      }
    });
    const __returned__ = { GalleryEdit, GalleryList, props, emit, getEmptyGallery, t, showGalleryDialog, showEditDialog, isValid, galleryData, validationMsg, wrapper, ImageWidth, ImageHeight, showDialog, validateRules, showSelectedGallery, clearGallery, openNewGallery, onSave, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardSection() {
      return QCardSection;
    }, get QDialog() {
      return QDialog;
    }, get QIcon() {
      return QIcon;
    }, GalleryPreviewCarousel: galleryPreviewCarousel, GalleryStateOverlay };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = { ref: "wrapper" };
const _hoisted_2 = { class: "row justify-center items-center align-center text-center" };
const _hoisted_3 = { class: "col-6" };
const _hoisted_4 = {
  key: 0,
  class: "required"
};
const _hoisted_5 = { class: "gallery--wrapper" };
const _hoisted_6 = { class: "gallery--description" };
const _hoisted_7 = { class: "q-mx-md" };
const _hoisted_8 = { class: "text-wrap q-mb-xs q-mt-sm" };
const _hoisted_9 = { class: "q-field__messages text-negative col" };
const _hoisted_10 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1,
    [
      createVNode($setup["QCard"], {
        flat: "",
        class: normalizeClass({ invalid: !$setup.isValid })
      }, {
        default: withCtx(() => [
          !$props.modelValue ? (openBlock(), createBlock($setup["QCardSection"], {
            key: 0,
            style: { "height": "100%" },
            "data-qa-gallery-picker": "",
            class: "border-item border-item--dashed",
            onClick: _cache[0] || (_cache[0] = ($event) => $setup.showGalleryDialog = true)
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2, [
                createElementVNode("div", _hoisted_3, [
                  createVNode($setup["QIcon"], {
                    size: "36px",
                    name: "gallery",
                    color: "grey-5"
                  }),
                  createVNode($setup["QCardSection"], {
                    flat: "",
                    color: "white"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(
                        toDisplayString($setup.t("galleryList.galleryLabel")) + " ",
                        1
                        /* TEXT */
                      ),
                      $props.required ? (openBlock(), createElementBlock("span", _hoisted_4)) : createCommentVNode("v-if", true)
                    ]),
                    _: 1
                    /* STABLE */
                  })
                ])
              ])
            ]),
            _: 1
            /* STABLE */
          })) : (openBlock(), createBlock($setup["QCardSection"], {
            key: 1,
            class: "q-pa-none"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_5, [
                createVNode($setup["GalleryPreviewCarousel"], {
                  references: $setup.galleryData.references,
                  "data-qa-gallery-preview-carousel": "",
                  "preview-size": { width: $setup.ImageWidth, height: $setup.ImageHeight }
                }, null, 8, ["references", "preview-size"]),
                createVNode($setup["GalleryStateOverlay"], { gallery: $setup.galleryData }, null, 8, ["gallery"]),
                createElementVNode("div", _hoisted_6, [
                  createElementVNode("div", _hoisted_7, [
                    createElementVNode(
                      "div",
                      _hoisted_8,
                      toDisplayString($setup.galleryData.title),
                      1
                      /* TEXT */
                    ),
                    createVNode($setup["QBtn"], {
                      "data-qa-gallery-picker-edit-button": "",
                      outline: "",
                      color: "white",
                      "text-color": "black",
                      label: $setup.t("galleryList.edit"),
                      class: "border-btn q-mr-sm",
                      onClick: _cache[1] || (_cache[1] = ($event) => $setup.showEditDialog = true)
                    }, null, 8, ["label"]),
                    createVNode($setup["QBtn"], {
                      "data-qa-gallery-picker-remove-button": "",
                      outline: "",
                      color: "white",
                      "text-color": "black",
                      label: $setup.t("galleryList.remove"),
                      class: "border-btn",
                      onClick: $setup.clearGallery
                    }, null, 8, ["label"])
                  ])
                ])
              ])
            ]),
            _: 1
            /* STABLE */
          })),
          $setup.validationMsg ? (openBlock(), createBlock($setup["QCardSection"], {
            key: 2,
            class: "q-field__bottom row items-start q-field__bottom--animated"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_9, [
                createElementVNode("div", {
                  role: "alert",
                  textContent: toDisplayString($setup.validationMsg)
                }, null, 8, _hoisted_10)
              ])
            ]),
            _: 1
            /* STABLE */
          })) : createCommentVNode("v-if", true)
        ]),
        _: 1
        /* STABLE */
      }, 8, ["class"]),
      createCommentVNode(" prop: allow-focus-outside - does solve problematic element focus when two modal windows overlap each other, bit of the workaround\n     should be investigated why it is necessary, since problem does happen only to production build (CTF-3964) "),
      createVNode($setup["QDialog"], {
        modelValue: $setup.showDialog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $setup.showDialog = $event),
        "allow-focus-outside": "",
        "data-qa-edit-gallery-dialog": "",
        "full-width": "",
        "full-height": "",
        container: ""
      }, {
        default: withCtx(() => [
          $setup.showEditDialog ? (openBlock(), createBlock($setup["GalleryEdit"], {
            key: 0,
            id: $props.modelValue,
            dialog: true,
            title: $props.modelValue ? $setup.t("gallery.router.editGallery") : $setup.t("gallery.router.createGallery"),
            "back-route": void 0,
            onClose: _cache[2] || (_cache[2] = ($event) => $setup.showEditDialog = false),
            "onBack:modal": _cache[3] || (_cache[3] = ($event) => $setup.showEditDialog = false),
            onSaveGallery: $setup.onSave
          }, null, 8, ["id", "title"])) : $setup.showGalleryDialog ? (openBlock(), createBlock($setup["GalleryList"], {
            key: 1,
            dialog: true,
            state: $props.state,
            brand: $props.license,
            "onClick:gallery": $setup.showSelectedGallery,
            onClose: _cache[4] || (_cache[4] = ($event) => $setup.showGalleryDialog = false),
            "onClick:gallery:new": _cache[5] || (_cache[5] = ($event) => $setup.openNewGallery())
          }, null, 8, ["state", "brand"])) : createCommentVNode("v-if", true)
        ]),
        _: 1
        /* STABLE */
      }, 8, ["modelValue"])
    ],
    512
    /* NEED_PATCH */
  );
}
const GalleryListSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-b2f94fe4"], ["__file", "/builds/CT/content-technology-framework/modules/gallery/editor-ui/src/selectors/gallery-list.selector.vue"]]);
const GalleryContentBlock = defineAsyncComponent(() => import("./gallery-content-block-Cll-x_yY.js"));
const galleryModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "GALLERY",
      label: "gallery.contentBlockLabel",
      icon: "gallery",
      component: GalleryContentBlock,
      defaultValue: getDefaultGalleryBlock()
    }
  ]
};
export {
  GalleryListSelector as G,
  _export_sfc as _,
  getGallery as a,
  galleryPreviewCarousel as b,
  GalleryService as c,
  deleteGallery as d,
  editGallery as e,
  GalleryContentBlock as f,
  getDefaultGalleryBlock as g,
  galleryModule as h,
  GalleryModelName as i,
  getGalleries as j,
  postGallery as p
};
//# sourceMappingURL=index-BYPCots8.js.map
